import { useEffect } from 'react';
import { useTracking } from 'react-tracking';
import { useFlagsDeprecated } from '@/features/flagrDeprecated';
import { setBaseUrl } from '@simplywallst/services';

export function useAppInit() {
  const { trackEvent } = useTracking();
  const flagResults = useFlagsDeprecated();
  useEffect(() => {
    if (
      flagResults.status === 'success' &&
      typeof flagResults.flags !== 'undefined'
    ) {
      trackEvent({
        type: 'track',
        subject: 'load',
        action: 'flagrInit',
        userFlags: flagResults.flags,
      });
    }
  }, [flagResults.status, flagResults.flags]);

  useEffect(() => {
    const registerServiceWorker = async () => {
      try {
        const registration = await navigator.serviceWorker.register(
          '/static/service-worker.js'
        );
        console.log('SW registered: ', registration);
      } catch (e) {
        console.log('SW registration failed: ', e);
      }
    };
    /** Register */
    if (
      NODE_ENV === 'production' &&
      'serviceWorker' in navigator &&
      RUNTIME_ENV === 'browser'
    ) {
      registerServiceWorker();
    }
  }, []);

  useEffect(() => {
    /** refresh on focus */
    let focusTime: number = Date.now();
    const onFocus = () => {
      const diff = Date.now() - focusTime;
      const sixHours = 21600000;
      if (diff > sixHours) {
        window.location.reload();
      }
    };
    const onBlur = () => {
      focusTime = Date.now();
    };
    window.addEventListener('focus', onFocus);
    window.addEventListener('blur', onBlur);
    return () => {
      window.removeEventListener('focus', onFocus);
      window.removeEventListener('blur', onBlur);
    };
  }, []);

  if (
    RUNTIME_ENV === 'server' &&
    typeof SWS_INTERNAL_API_BASE_URL !== 'undefined'
  ) {
    setBaseUrl(SWS_INTERNAL_API_BASE_URL);
  }

  /**
   * To surface tests that are missing stubs (and therefore flaky),
   * set DEBUG_FLAKY_TESTS to true, and run Cypress tests.
   */
  const DEBUG_FLAKY_TESTS = false;

  // TODO: Fix flaky tests and remove this configuration.
  if (DEBUG_FLAKY_TESTS && TEST_RUNNER === 'cypress') {
    setBaseUrl('https://not-stable-dev.simplywall.st/');
  }
}
